export default function loadSchemaScript(url) {
    return new Promise((resolve, reject) => {
        const baseUrl = window.location.origin ?? '';
        const logoUrl = `${baseUrl}${url}${window.SHEMAORGLOGO}`;

        const schemaData = {
            '@context': 'https://schema.org',
            '@type': 'website',
            name: window.SHEMAORGTITLE,
            description: window.SHEMAORGDESCRIPTION,
            url: window.SHEMAORGURL || window.location.origin,
            logo: logoUrl
        };

        const script = document.createElement('script');
        script.type = 'application/ld+json';
        script.textContent = JSON.stringify(schemaData);
        document.head.appendChild(script);

        fetch(logoUrl, { method: 'HEAD' })
            .then(response => {
                if (response.ok) {
                    resolve(schemaData);
                } else {
                    reject(new Error(`Logo не найдено: ${logoUrl}`));
                }
            })
            .catch(() => {
                reject(new Error(`Logo не доступно: ${logoUrl}`));
            });
    });
}
